(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/game-guide/game-guide.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/game-guide/game-guide.js');
'use strict';

const {
  useState,
  useEffect
} = React;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  fetchGameGuideArticles
} = svs.arena.store.gameguide.actions;
const GameGuide = () => {
  const dispatch = ReactRedux.useDispatch();
  const articles = ReactRedux.useSelector(state => {
    var _state$gameguide;
    return (_state$gameguide = state.gameguide) === null || _state$gameguide === void 0 ? void 0 : _state$gameguide.articles;
  }) || [];
  const [selectedItem, setSelectedItem] = useState();
  useEffect(() => {
    svs.arena.logger.debug('GameGuide, useEffect...fetchGameGuideArticles...');
    dispatch(fetchGameGuideArticles());
  }, [dispatch]);
  useEffect(() => {
    if (articles && articles.length > 0) {
      setSelectedItem(articles[0]);
    }
  }, [articles]);
  const changeArticle = (e, item) => {
    const track = {
      category: 'spela-tillsammans',
      action: 'Spelguide_meny',
      opt_label: item.title ? item.title.replace('', '_') : 'Undefined tab'
    };
    svs.components.analytics.trackEvent(track);
    e.preventDefault();
    setSelectedItem(item);
  };


  return React.createElement("div", null, articles && articles.length > 0 && React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true
    ,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, articles.map(item => React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    key: item.id,
    label: item.title,
    onClick: e => changeArticle(e, item),
    selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id
  }))), selectedItem && React.createElement("div", {
    className: "simple-article-content padding-xs-2 padding-md-3 pop-up-box f-content",
    dangerouslySetInnerHTML: {
      __html: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.body
    }
  }));
};
svs.arena.pages.GameGuide = GameGuide;

 })(window);